import type { ValidationError } from "@tanstack/react-form"
import { SETUP_GOALS } from "../constants"

export const forecastValidator = (getGoalValue: () => string | undefined) => {
  return ({ value }: { value: string | undefined }): ValidationError | undefined => {
    const goal = getGoalValue()

    if (goal === SETUP_GOALS.TARGET_TOTAL_RISK && (value === undefined || value === "none")) {
      return "Forecast is required when Target Total Risk is selected"
    }

    return undefined
  }
}
